import { render, staticRenderFns } from "./PopupScopeGDLS.vue?vue&type=template&id=40d5ae90&scoped=true&lang=pug&"
import script from "./PopupScopeGDLS.vue?vue&type=script&lang=ts&"
export * from "./PopupScopeGDLS.vue?vue&type=script&lang=ts&"
import style0 from "./PopupScopeGDLS.vue?vue&type=style&index=0&id=40d5ae90&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d5ae90",
  null
  
)

export default component.exports